export function upravStranku() {
  $(".footer-banners").insertAfter(
    ".homepage-box.before-carousel .row.banners-row"
  );
} //function  upravStranku()
